import type { LeaveApplicableGender } from "../types";

/**
 * Returns true when the employee's gender is eligible for the given leave type.
 * When the employee's gender is unknown we default to showing the leave type
 * (conservative inclusion).
 */
export function genderMatches(
  employeeGender: string | null | undefined,
  applicableGender: LeaveApplicableGender | string,
): boolean {
  if (applicableGender === "ALL") return true;
  if (!employeeGender) return true;
  const eg = employeeGender.toUpperCase();
  if (applicableGender === "FEMALE") return eg.includes("FEMALE") || eg === "F";
  if (applicableGender === "MALE")   return (eg.includes("MALE") && !eg.includes("FEMALE")) || eg === "M";
  return true;
}
